import React from "react";
import { useForm } from "react-hook-form";
import ModalPopup from "../../Modal/ModalPopup";
import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../Button/Button";
import { ADD_PRODUCT_COLOR_DATA } from "../../../Redux-Toolkit/Actions/sagaActions";
import { useDispatch } from "react-redux";
import { resetpassword } from "../../../config/routingConsts";
import { useState } from "react";

const AddColorModel = ({ colorModalShow, setColorModalShow ,onChange }) => {
  const validationSchema = yup.object({
    addColor: yup
      .string()
      .required("Please Enter Color Name")
      .max(20, "Input Color Must be 0 to 20 Characters Long."),
    // addColor: yup
    // .string()
    // .test('customessage', 'Please Select Color.', (value) => {
    //  if(value){
    //     return false
    //  }
    //  else {
    //    return true
    //  }
    // })
  });
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema), mode: "all" });
  const dispatch = useDispatch();
  const [colorInput,setColorInput] = useState('')


  const onSubmit = (data) => { 
    // data?.addColor
    dispatch({
      type: ADD_PRODUCT_COLOR_DATA,
      payload: { color:  colorInput , callback : (e)=>{
        onChange(e)
      } },
    });
    setColorModalShow(false);
    // reset()
  };
  return (

    <>
       <ModalPopup
                show={colorModalShow}
                handleClose={() => {
                  setColorModalShow(false)
                }}
                handleShow={() => {
                  setColorModalShow(true)
                }}
                cname="accept-item confirm-modal delete-modal"
            >
               <form>
                            <h2>Add Product Color</h2>
                            <div className="form-group">
                              {/* add this in label for showing colorpicker  for = "addColor" */}
                                <label>Add Color</label>    
                                <input
                                    type="text" 
                                    // type="color"
                                    name="addColor"
                                    autoFocus={false}
                                    {...register('addColor',{onChange : (e)=>{setColorInput(e.target.value)}})}
                                    autoComplete="off"
                                />
                                {errors?.addColor?.message && (
                                    <span style={{ color: 'red' }}>
                                        {errors?.addColor?.message}
                                    </span>
                                )}
                            </div>
                            <div className="modal-btn-group">
                                <Button
                                    type="button"
                                    commonClass="solid-black-btn modal-btn "
                                    text="No"
                                    onClick={() => {
                                        setColorModalShow(false)
                                        reset()
                                    }}
                                />
                                <Button
                                    type = "button"
                                    commonClass="solid-red-btn modal-btn "
                                    text="Yes"
                                    onClick={async ()=>{await trigger('addColor') && onSubmit()}}
                                />
                            </div>
                        </form>
            </ModalPopup>
    </>
  );
};

export default AddColorModel;
